import type { ReactElement, ReactNode } from 'react';

export interface PageHeaderProps {
  title: string;
  description?: string;
  /** Right-aligned actions, once there are any. */
  children?: ReactNode;
}

export function PageHeader({ title, description, children }: PageHeaderProps): ReactElement {
  return (
    <header className="page-header">
      <div>
        <h2 className="page-header__title">{title}</h2>
        {description !== undefined ? (
          <p className="page-header__description">{description}</p>
        ) : null}
      </div>
      {children !== undefined ? <div className="page-header__actions">{children}</div> : null}
    </header>
  );
}
